// import Main from '@/views/main/Main.vue';
import userChild from './userChild';
import main from './main/index';
import auth from './auth/index';
import guide from './guide/index';
import share from './share/index';

/**
 * meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String } 标题
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  hideInMenuTitle: (false) 设为true后在左侧菜单不会显示该选项，但有子级就显示
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，iconfont图标一定是icon开头
 * }
 */

const routes = [
    {
        path: '/payresult',
        name: 'payresult',
        component: () => import(/* webpackChunkName: "combind" */'@/views/pay/PayResult.vue'),
        props: (route:any) => {
            return {
                ...route.query,
            };
        },
        meta: {
            title: 'Payresult',
            hideInMenu: true,
        },
    },
    { // 后面考虑改掉， 用auth
        path: '/authresult',
        name: 'auth_result',
        redirect: '/auth/result',
        meta: {
            title: 'AuthResult',
            hideInMenu: true,
        },
    },
    {
        path: '/auth',
        name: 'auth',
        meta: {
            hideInMenu: true,
        },
        component: () => import(/* webpackChunkName: "auth" */'@/views/auth/index.vue'),
        redirect: '/auth/result',
        children: auth,
    },
    // 用于分享给外部的链接页面
    ...share,
    {
        path: '/guide',
        name: 'guide',
        meta: {
            hideInMenu: true,
        },
        component: () => import(/* webpackChunkName: "combind" */'@/views/guide/index.vue'),
        children: guide,
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "ss" */'@/views/login/Login.vue'),
        meta: {
            title: 'Login',
            hideInMenu: true,
        },
    },
    {
        path: '/registration',
        name: 'registration',
        component: () => import(/* webpackChunkName: "ss" */'@/views/registration/Registration.vue'),
        meta: {
            title: 'Registration',
            hideInMenu: true,
        },
    },
    {
        path: '/forgetpassword',
        name: 'forgetpassword',
        component: () => import(/* webpackChunkName: "ss" */'@/views/forgetpassword/Forgetpassword.vue'),
        meta: {
            title: 'Forgetpassword',
            hideInMenu: true,
        },
    },
    {
        path: '/registration_success',
        name: 'registrationSuccess',
        component: () => import(/* webpackChunkName: "ss" */'@/views/registration/RegistrationSuccess.vue'),
        meta: {
            title: 'RegistrationSuccess',
            hideInMenu: true,
        },
    },
    {
        path: '/active_user',
        name: 'activeUser',
        component: () => import(/* webpackChunkName: "combind" */'@/views/registration/ActiveUser.vue'),
        meta: {
            title: 'ActiveUser',
            hideInMenu: true,
        },
    },
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "ss" */'@/views/main/Main.vue'),
        meta: {
            hideInBread: true,
            hideInMenu: true,
            access: ['AUTH_HOME_PAGE'],
        },
    },
    {
        path: '/user',
        name: 'user',
        redirect: '/user/accounts',
        component: () => import(/* webpackChunkName: "ss" */'@/views/main/Main.vue'),
        meta: {
            hideInMenu: true,
        },
        children: userChild,
    },
    {
        path: '/',
        name: 'main',
        meta: {
            title: 'main',
            icon: 'ios-archive',
            notPageView: true,
        },
        component: () => import(/* webpackChunkName: "ss" */'@/views/main/Main.vue'),
        children: main,
    },
    {
        path: '/guide',
        component: () => import(/* webpackChunkName: "ss" */'@/views/main/Main.vue'),
        meta: {
            hideInMenu: true,
        },
        children: [
            {
                path: 'welcome',
                name: 'welcome',
                meta: {
                    title: 'welcome',
                    hideInMenu: true,
                    icon: 'icon-zhinan',
                },
                redirect: '/home',
                component: () => import(/* webpackChunkName: "combind" */'@/views/guide/Welcome.vue'),
            },
        ],
    },
    {
        path: '/no_project',
        name: 'noProject',
        meta: {
            hideInMenu: true,
        },
        component: () => import(/* webpackChunkName: "ss" */'@/views/error/NoProject.vue'),
    },
    {
        path: '/bigcommerce_transit',
        name: 'bigcommerceTransit',
        meta: {
            title: 'bigcommerce_transit',
            hideInMenu: true,
        },
        component: () => import(/* webpackChunkName: "combind" */'@/views/transit/bigcommerceTransitPage.vue'),
    },
    {
        path: '/automated_links',
        name: 'automatedLinks',
        meta: {
            title: 'automated_links',
            hideInMenu: true,
        },
        component: () => import(/* webpackChunkName: "combind" */'@/views/transit/automatedLinksPage.vue'),
    },
    {
        // 账单下载页
        path: '/fee_receipt/:id',
        name: 'feeReceipt',
        meta: {
            hideInMenu: true,
        },
        component: () => import(/* webpackChunkName: "ss" */'@/views/main/setting/Fee/receipt.vue'),
    },
    {
        path: '/error401',
        name: 'error401',
        meta: {
            hideInMenu: true,
        },
        component: () => import(/* webpackChunkName: "ss" */'@/views/error/401.vue'),
    },
    {
        path: '*',
        name: 'error404',
        meta: {
            hideInMenu: true,
        },
        component: () => import(/* webpackChunkName: "ss" */'@/views/error/404.vue'),
    },
];

export default routes;
